export default __webpack_public_path__ + "static/10-710550dda9d77399a4fe5cb37db5cd93.png";